import React from 'react';
import Spinner from '../Spinner/Spinner';
import './Results.css';

const Results = ({ results, processing }) => {
  if (processing && results) {
    return <Spinner />;
  }
  if (!processing && results && results.length > 0) {
    return (
      <div className="results">
        {results.length > 1 ? (
          <div>
            {results.map((result, i) => (
              <div className="results__wrapper" key={i}>
                <div style={{ width: '300px' }}>
                  <p>
                    One probably {result.gender} student, is looking {result.expressions.asSortedArray()[0].expression}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="results__wrapper">
            <div>
              <p>Emotions : {results[0].expressions.asSortedArray()[0].expression}</p>
              <p>Gender : {results[0].gender}</p>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className="results">
        <Spinner />
      </div>
    );
  }
};

export default Results;
